import React from 'react'
import "./first-onboard-screen.css"

const FirstOnboardScreen = ({show, onClose, onClickOut}) => {
    return (
        <div onClick={onClickOut} className={`obw-overlay ${show ? "show" : ""}`}>
            <div onClick={e => e.stopPropagation()} className="obw-card">
                <div className="obw-ambient"></div>

                <div className="obw-hero">
                    <div className="obw-hero-gradient"></div>
                    <video
                        className="obw-video"
                        autoPlay={'autoplay'}
                        loop
                        muted
                        playsInline
                    >
                        <source
                            type="video/mp4"
                            src="/assets/file/videos/HomepageVideoNew.mp4"
                        />
                        <source
                            type="video/webm"
                            src="https://d5l8cb2ud43ux.cloudfront.net/HomepageVideoNew_rc6vmu.webm"
                        />
                    </video>
                </div>

                <div className="obw-body">
                    <h2 className="obw-greeting">
                        היי, טוב לראות אותך <span className="obw-wave">👋</span>
                    </h2>
                    <p className="obw-description">
                        לעצב את קירות הבית או המשרד עם בלנדס<br/>
                        .זו דרך נהדרת להכניס רגשות וחיים לאיזור
                    </p>
                </div>

                <div className="obw-footer">
                    <button onClick={onClose} className="obw-cta">
                        <span>המשך</span>
                        <svg className="obw-cta-arrow" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M11 13.5L6.5 9L11 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FirstOnboardScreen;
